import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  { title: '1. 個人情報の収集について', content: '当社は、お問い合わせの受付やサービスの提供に必要な範囲で、お客様の個人情報（氏名、会社名、メールアドレス、電話番号等）を収集します。収集にあたっては、適法かつ公正な手段によって行います。' },
  { title: '2. 個人情報の利用目的', content: '収集した個人情報は、以下の目的に利用します。\n・お問い合わせへの回答および対応\n・サービスに関するご案内・情報提供\n・契約履行および関連する業務の遂行\n・法令に基づく対応' },
  { title: '3. 個人情報の第三者提供', content: '当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供しません。\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要な場合\n・公衆衛生の向上または児童の健全な育成の推進のために必要な場合' },
  { title: '4. 個人情報の管理・安全対策', content: '当社は、個人情報の漏洩・滅失・棄損の防止その他個人情報の安全管理のために必要かつ適切な措置を講じます。' },
  { title: '5. 個人情報の開示・訂正・削除', content: 'お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除等を請求することができます。ご請求はお問い合わせフォームよりご連絡ください。' },
  { title: '6. Cookieおよびアクセス解析について', content: '当社ウェブサイトでは、サービス向上のためCookieを使用しています。また、Google Analyticsを利用してアクセス解析を行っており、収集されたデータはGoogleのプライバシーポリシーに従って管理されます。' },
  { title: '7. プライバシーポリシーの変更', content: '当社は、法令の改正等の必要に応じて、本プライバシーポリシーを適宜見直し、変更することがあります。' },
  { title: '8. お問い合わせ', content: '個人情報の取り扱いに関するお問い合わせは、以下の窓口までご連絡ください。\n\n会社名：Grandeur Architect株式会社\n代表者：山内　紫央里\n所在地：〒530-0043 大阪市北区天満四丁目１４番２ー５０２号\nメール：info.customer@grandeur-architect.com\n電話番号：050-8895-1393 / 080-2943-2049\n受付時間：月曜〜金曜 9:00〜18:00（土日・祝日休業）' },
];

const dotColors = ['#38BDF8', '#F472B6', '#FBBF24', '#A3E635', '#FB923C', '#C084FC', '#38BDF8', '#F472B6'];

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <section className="relative pt-36 pb-16 overflow-hidden" style={{ background: 'linear-gradient(135deg, #C084FC 0%, #F472B6 50%, #FBBF24 100%)' }}>
        <div className="absolute top-8 right-16 w-40 h-40 bg-white/10 rounded-full" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-black px-4 py-2 rounded-full mb-6 uppercase tracking-wider backdrop-blur-sm">🔒 Privacy Policy</div>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4 drop-shadow-sm">プライバシーポリシー</h1>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="rounded-3xl p-6 mb-12" style={{ background: '#F8F9FF', border: '2px solid #E0E7FF' }}>
            <p className="text-sm text-gray-600 leading-relaxed font-medium">
              Grandeur Architect株式会社（以下「当社」）は、お客様の個人情報の保護を重要な責務と認識し、個人情報の保護に関する法律（個人情報保護法）その他関係法令を遵守するとともに、以下のプライバシーポリシーに従い、お客様の個人情報を適切に取り扱います。
            </p>
          </div>
          <div className="space-y-10">
            {sections.map((section, i) => (
              <div key={section.title}>
                <h2 className="text-lg font-black text-gray-900 mb-4 flex items-center gap-3">
                  <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: dotColors[i] }} />
                  {section.title}
                </h2>
                <div className="text-sm text-gray-600 leading-relaxed whitespace-pre-line pl-6 font-medium">{section.content}</div>
              </div>
            ))}
          </div>
          <div className="border-t border-gray-100 mt-16 pt-8 text-center">
            <p className="text-xs text-gray-400 font-medium">Grandeur Architect株式会社<br />大阪市北区天満四丁目１４番２ー５０２号</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
